

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
		console.log('click');
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  summary.addEventListener('mouseenter', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

// class HeaderDrawer extends MenuDrawer {
//   constructor() {
//     super();
//   }

//   openMenuDrawer(summaryElement) {
//     this.header = this.header || document.getElementById('shopify-section-header');
//     this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
//     document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

//     setTimeout(() => {
//       this.mainDetailsToggle.classList.add('menu-opening');
//     });

//     summaryElement.setAttribute('aria-expanded', true);
//     trapFocus(this.mainDetailsToggle, summaryElement);
//     document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
//   }
// }

// customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // Fetch the new section HTML from Shopify (optional, if you still want to refresh other parts)
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // 1️⃣ Update the native Shopify DOM section (if needed)
        const sectionId = this.dataset.section;
        const priceId = `price-${sectionId}`;
  
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newPriceEl = html.getElementById(priceId);
        const currentPriceEl = document.getElementById(priceId);
  
        if (newPriceEl && currentPriceEl) {
          currentPriceEl.innerHTML = newPriceEl.innerHTML;
        }
  
        // 2️⃣ Inject our custom price display based on the current variant
        this.updatePriceDOM(this.currentVariant);
  
        // 3️⃣ Show price wrapper again (Shopify hides during render)
        const priceWrapper = document.getElementById(priceId);
        if (priceWrapper) priceWrapper.classList.remove('visibility-hidden');
  
        // 4️⃣ Toggle Add-to-Cart button state
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch((err) => {
        console.error('renderProductInfo fetch error:', err);
      });
  }

  updatePriceDOM(variantJSON) {
    const variant = typeof variantJSON === 'string' ? JSON.parse(variantJSON) : variantJSON;
    const html = this.buildPriceHTML(variant);
  
    const container = document.querySelector('.product-info-price-wrapper');
    if (!container) return;
  
    container.innerHTML = html;
  }

  buildPriceHTML(variant) {
    const quantity = parseInt(variant.option1) || 1;
  
    const price = variant.price;
    const compareAt = variant.compare_at_price;
  
    const pricePerCapsule = (price / 100) / quantity;
  
    const pricePerCapsuleFormatted = pricePerCapsule.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  
    // Build the final HTML block
    const html = `
      <div class="mb-2 flex" style="gap: 2rem;">
        <div>
          <legend class="form__label"></legend>
          <div class="d-flex flex-column">
            ${compareAt && compareAt > price ? `
              <span class="bold price-item--sale">
                ${this.formatCurrency(compareAt)}<sup></sup><span class="cents">MXN</span>
              </span>` : ''}
            <div class="flex align-items-center gap-0-5rem">
              <span class="bold text-large">${this.formatCurrency(price)}<sup></sup><span class="cents">MXN</span></span>
              <span class="bold text-small calculated-pill-price">(${pricePerCapsuleFormatted} / cápsula)</span>
            </div>
          </div>
        </div>
      </div>
    `;
  
    return html.trim();
  }
  
  formatCurrency(value) {
    // Shopify prices are in cents
    const pesos = value / 100;
    // Format as Mexican pesos
    return pesos.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }
  
  

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`ProductFormApp`);
    if (!productForm) return;
    const addButton = productForm.querySelector('.product-form__submit');
    const addButtonText = productForm.querySelector('.product-form__submit > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      addButton.classList.add('disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('disabled');
      document.querySelector('.product-form__add-to-cart').classList.remove('sold-out');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const form = document.getElementById(`ProductFormApp`);
    const addButton = form.querySelector('.product-form__submit');
    const addButtonText = form.querySelector('.product-form__submit > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);


// custom code

let DoublyCurrency = {}
DoublyCurrency.moneyFormats = {
	USD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} USD"
	},
	EUR: {
		money_format: ("&euro;{{" + DoublyGlobal.euroFormat + "}}"),
		money_with_currency_format: ("&euro;{{" + DoublyGlobal.euroFormat + "}} EUR")
	},
	GBP: {
		money_format: "&pound;{{amount}}",
		money_with_currency_format: "&pound;{{amount}} GBP"
	},
	CAD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} CAD"
	},
	ALL: {
		money_format: "Lek {{amount}}",
		money_with_currency_format: "Lek {{amount}} ALL"
	},
	DZD: {
		money_format: "DA {{amount}}",
		money_with_currency_format: "DA {{amount}} DZD"
	},
	AOA: {
		money_format: "Kz{{amount}}",
		money_with_currency_format: "Kz{{amount}} AOA"
	},
	ARS: {
		money_format: "${{amount_with_comma_separator}}",
		money_with_currency_format: "${{amount_with_comma_separator}} ARS"
	},
	AMD: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} AMD"
	},
	AWG: {
		money_format: "Afl{{amount}}",
		money_with_currency_format: "Afl{{amount}} AWG"
	},
	AUD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} AUD"
	},
	BBD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} Bds"
	},
	AZN: {
		money_format: "&#8380;{{amount}}",
		money_with_currency_format: "&#8380;{{amount}} AZN"
	},
	BDT: {
		money_format: "Tk {{amount}}",
		money_with_currency_format: "Tk {{amount}} BDT"
	},
	BSD: {
		money_format: "BS${{amount}}",
		money_with_currency_format: "BS${{amount}} BSD"
	},
	BHD: {
		money_format: "{{amount}} BD",
		money_with_currency_format: "{{amount}} BHD"
	},
	BYN: {
		money_format: "Br {{amount}}",
		money_with_currency_format: "Br {{amount}} BYN"
	},
	BZD: {
		money_format: "BZ${{amount}}",
		money_with_currency_format: "BZ${{amount}} BZD"
	},
	BTN: {
		money_format: "Nu {{amount}}",
		money_with_currency_format: "Nu {{amount}} BTN"
	},
	BAM: {
		money_format: "KM {{amount_with_comma_separator}}",
		money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
	},
	BRL: {
		money_format: "R$ {{amount_with_comma_separator}}",
		money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
	},
	BOB: {
		money_format: "Bs{{amount_with_comma_separator}}",
		money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
	},
	BWP: {
		money_format: "P{{amount}}",
		money_with_currency_format: "P{{amount}} BWP"
	},
	BND: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} BND"
	},
	BGN: {
		money_format: "{{amount}} Ð»Ð²",
		money_with_currency_format: "{{amount}} Ð»Ð² BGN"
	},
	MMK: {
		money_format: "K{{amount}}",
		money_with_currency_format: "K{{amount}} MMK"
	},
	KHR: {
		money_format: "KHR{{amount}}",
		money_with_currency_format: "KHR{{amount}}"
	},
	KYD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} KYD"
	},
	XAF: {
		money_format: "FCFA{{amount}}",
		money_with_currency_format: "FCFA{{amount}} XAF"
	},
	CLP: {
		money_format: "${{amount_no_decimals}}",
		money_with_currency_format: "${{amount_no_decimals}} CLP"
	},
	CNY: {
		money_format: "&#165;{{amount}}",
		money_with_currency_format: "&#165;{{amount}} CNY"
	},
	COP: {
		money_format: "${{amount_with_comma_separator}}",
		money_with_currency_format: "${{amount_with_comma_separator}} COP"
	},
	CRC: {
		money_format: "&#8353; {{amount_with_comma_separator}}",
		money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
	},
	HRK: {
		money_format: "{{amount_with_comma_separator}} kn",
		money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
	},
	CZK: {
		money_format: "{{amount_with_comma_separator}} K&#269;",
		money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
	},
	DKK: {
		money_format: "kr {{amount_with_comma_separator}}",
		money_with_currency_format: "kr {{amount_with_comma_separator}} DKK"
	},
	DOP: {
		money_format: "RD$ {{amount}}",
		money_with_currency_format: "RD${{amount}}"
	},
	XCD: {
		money_format: "$ {{amount}}",
		money_with_currency_format: "EC${{amount}}"
	},
	EGP: {
		money_format: "LE {{amount}}",
		money_with_currency_format: "LE {{amount}} EGP"
	},
	ETB: {
		money_format: "Br{{amount}}",
		money_with_currency_format: "Br{{amount}} ETB"
	},
	XPF: {
		money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
		money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
	},
	FJD: {
		money_format: "${{amount}}",
		money_with_currency_format: "FJ${{amount}}"
	},
	GMD: {
		money_format: "D {{amount}}",
		money_with_currency_format: "D {{amount}} GMD"
	},
	GHS: {
		money_format: "GH&#8373;{{amount}}",
		money_with_currency_format: "GH&#8373;{{amount}}"
	},
	GTQ: {
		money_format: "Q{{amount}}",
		money_with_currency_format: "{{amount}} GTQ"
	},
	GYD: {
		money_format: "G${{amount}}",
		money_with_currency_format: "${{amount}} GYD"
	},
	GEL: {
		money_format: "{{amount}} GEL",
		money_with_currency_format: "{{amount}} GEL"
	},
	HNL: {
		money_format: "L {{amount}}",
		money_with_currency_format: "L {{amount}} HNL"
	},
	HKD: {
		money_format: "HK${{amount}}",
		money_with_currency_format: "HK${{amount}} HKD"
	},
	HUF: {
		money_format: "{{amount_no_decimals_with_comma_separator}} Ft",
		money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft HUF"
	},
	ISK: {
		money_format: "{{amount_no_decimals}} kr",
		money_with_currency_format: "{{amount_no_decimals}} kr ISK"
	},
	INR: {
		money_format: "&#8377; {{amount}}",
		money_with_currency_format: "&#8377; {{amount}} INR"
	},
	IDR: {
		money_format: "{{amount_with_comma_separator}} IDR",
		money_with_currency_format: "Rp {{amount_with_comma_separator}} IDR"
	},
	ILS: {
		money_format: "&#8362;{{amount}}",
		money_with_currency_format: "&#8362;{{amount}} NIS"
	},
	JMD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} JMD"
	},
	JPY: {
		money_format: "&#165;{{amount_no_decimals}}",
		money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
	},
	JEP: {
		money_format: "&pound;{{amount}}",
		money_with_currency_format: "&pound;{{amount}} JEP"
	},
	JOD: {
		money_format: "{{amount}} JD",
		money_with_currency_format: "{{amount}} JOD"
	},
	KZT: {
		money_format: "{{amount}} KZT",
		money_with_currency_format: "{{amount}} KZT"
	},
	KES: {
		money_format: "KSh{{amount}}",
		money_with_currency_format: "KSh{{amount}}"
	},
	KWD: {
		money_format: "{{amount}} KD",
		money_with_currency_format: "{{amount}} KWD"
	},
	KGS: {
		money_format: "Ð»Ð²{{amount}}",
		money_with_currency_format: "Ð»Ð²{{amount}}"
	},
	LVL: {
		money_format: "Ls {{amount}}",
		money_with_currency_format: "Ls {{amount}} LVL"
	},
	LBP: {
		money_format: "L.L.{{amount}}",
		money_with_currency_format: "L.L.{{amount}} LBP"
	},
	LTL: {
		money_format: "{{amount}} Lt",
		money_with_currency_format: "{{amount}} Lt"
	},
	MGA: {
		money_format: "Ar {{amount}}",
		money_with_currency_format: "Ar {{amount}} MGA"
	},
	MKD: {
		money_format: "Ð´ÐµÐ½ {{amount}}",
		money_with_currency_format: "Ð´ÐµÐ½ {{amount}} MKD"
	},
	MOP: {
		money_format: "MOP${{amount}}",
		money_with_currency_format: "MOP${{amount}}"
	},
	MVR: {
		money_format: "Rf{{amount}}",
		money_with_currency_format: "Rf{{amount}} MVR"
	},
	MXN: {
		money_format: "$ {{amount}}",
		money_with_currency_format: "$ {{amount}} MXN"
	},
	MYR: {
		money_format: "RM{{amount}}",
		money_with_currency_format: "RM{{amount}} MYR"
	},
	MUR: {
		money_format: "Rs {{amount}}",
		money_with_currency_format: "Rs {{amount}} MUR"
	},
	MDL: {
		money_format: "{{amount}} MDL",
		money_with_currency_format: "{{amount}} MDL"
	},
	MAD: {
		money_format: "{{amount}} dh",
		money_with_currency_format: "Dh {{amount}} MAD"
	},
	MNT: {
		money_format: "{{amount_no_decimals}} &#8366",
		money_with_currency_format: "{{amount_no_decimals}} MNT"
	},
	MZN: {
		money_format: "{{amount}} Mt",
		money_with_currency_format: "Mt {{amount}} MZN"
	},
	NAD: {
		money_format: "N${{amount}}",
		money_with_currency_format: "N${{amount}} NAD"
	},
	NPR: {
		money_format: "Rs{{amount}}",
		money_with_currency_format: "Rs{{amount}} NPR"
	},
	ANG: {
		money_format: "&fnof;{{amount}}",
		money_with_currency_format: "{{amount}} NA&fnof;"
	},
	NZD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} NZD"
	},
	NIO: {
		money_format: "C${{amount}}",
		money_with_currency_format: "C${{amount}} NIO"
	},
	NGN: {
		money_format: "&#8358;{{amount}}",
		money_with_currency_format: "&#8358;{{amount}} NGN"
	},
	NOK: {
		money_format: "kr {{amount_with_comma_separator}}",
		money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
	},
	OMR: {
		money_format: "{{amount_with_comma_separator}} OMR",
		money_with_currency_format: "{{amount_with_comma_separator}} OMR"
	},
	PKR: {
		money_format: "Rs.{{amount}}",
		money_with_currency_format: "Rs.{{amount}} PKR"
	},
	PGK: {
		money_format: "K {{amount}}",
		money_with_currency_format: "K {{amount}} PGK"
	},
	PYG: {
		money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
		money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
	},
	PEN: {
		money_format: "S/. {{amount}}",
		money_with_currency_format: "S/. {{amount}} PEN"
	},
	PHP: {
		money_format: "&#8369;{{amount}}",
		money_with_currency_format: "&#8369;{{amount}} PHP"
	},
	PLN: {
		money_format: "{{amount_with_comma_separator}} zl",
		money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
	},
	QAR: {
		money_format: "QAR {{amount_with_comma_separator}}",
		money_with_currency_format: "QAR {{amount_with_comma_separator}}"
	},
	RON: {
		money_format: "{{amount_with_comma_separator}} lei",
		money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
	},
	RUB: {
		money_format: "&#8381; {{amount_with_comma_separator}}",
		money_with_currency_format: "&#8381; {{amount_with_comma_separator}} RUB"
	},
	/*RUB: { money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}", money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB" }, */
	RWF: {
		money_format: "{{amount_no_decimals}} RF",
		money_with_currency_format: "{{amount_no_decimals}} RWF"
	},
	WST: {
		money_format: "WS$ {{amount}}",
		money_with_currency_format: "WS$ {{amount}} WST"
	},
	SAR: {
		money_format: "{{amount}} SR",
		money_with_currency_format: "{{amount}} SAR"
	},
	STD: {
		money_format: "Db {{amount}}",
		money_with_currency_format: "Db {{amount}} STD"
	},
	RSD: {
		money_format: "{{amount}} RSD",
		money_with_currency_format: "{{amount}} RSD"
	},
	SCR: {
		money_format: "Rs {{amount}}",
		money_with_currency_format: "Rs {{amount}} SCR"
	},
	SGD: {
		money_format: "S${{amount}}",
		money_with_currency_format: "S${{amount}} SGD"
	},
	SYP: {
		money_format: "S&pound;{{amount}}",
		money_with_currency_format: "S&pound;{{amount}} SYP"
	},
	ZAR: {
		money_format: "R {{amount}}",
		money_with_currency_format: "R {{amount}} ZAR"
	},
	KRW: {
		money_format: "&#8361;{{amount_no_decimals}}",
		money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
	},
	LKR: {
		money_format: "Rs {{amount}}",
		money_with_currency_format: "Rs {{amount}} LKR"
	},
	SEK: {
		money_format: "kr {{amount_with_comma_separator}}",
		money_with_currency_format: "kr {{amount_with_comma_separator}} SEK"
	},
	CHF: {
		money_format: "{{amount}} CHF",
		money_with_currency_format: "{{amount}} CHF"
	},
	TWD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} TWD"
	},
	THB: {
		money_format: "{{amount}} &#xe3f;",
		money_with_currency_format: "{{amount}} &#xe3f; THB"
	},
	TZS: {
		money_format: "{{amount}} TZS",
		money_with_currency_format: "{{amount}} TZS"
	},
	TTD: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}} TTD"
	},
	TND: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} DT"
	},
	TRY: {
		money_format: "{{amount}} TL",
		money_with_currency_format: "{{amount}} TL"
	},
	UGX: {
		money_format: "Ush {{amount_no_decimals}}",
		money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
	},
	UAH: {
		money_format: "â‚´{{amount}}",
		money_with_currency_format: "â‚´{{amount}} UAH"
	},
	AED: {
		money_format: "{{amount}} Ø¯.Ø¥",
		money_with_currency_format: "{{amount}} Ø¯.Ø¥ AED"
	},
	UYU: {
		money_format: "${{amount_with_comma_separator}}",
		money_with_currency_format: "${{amount_with_comma_separator}} UYU"
	},
	VUV: {
		money_format: "${{amount}}",
		money_with_currency_format: "${{amount}}VT"
	},
	VEF: {
		money_format: "Bs. {{amount_with_comma_separator}}",
		money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
	},
	VND: {
		money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
		money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
	},
	BTC: {
		money_format: "{{amount_no_decimals}} BTC",
		money_with_currency_format: "{{amount_no_decimals}} BTC"
	},
	XOF: {
		money_format: "CFA{{amount}}",
		money_with_currency_format: "CFA{{amount}} XOF"
	},
	ZMW: {
		money_format: "K{{amount_no_decimals_with_comma_separator}}",
		money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
	},
	AFN: {
		money_format: "&#65;&#102; {{amount}}",
		money_with_currency_format: "&#65;&#102; {{amount}} AFN"
	},
	BMD: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} BMD"
	},
	BIF: {
		money_format: "&#70;&#66;&#117; {{amount}}",
		money_with_currency_format: "&#70;&#66;&#117; {{amount}} BIF"
	},
	CVE: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} CVE"
	},
	KMF: {
		money_format: "&#67;&#70; {{amount}}",
		money_with_currency_format: "&#67;&#70; {{amount}} KMF"
	},
	CDF: {
		money_format: "&#70;&#67; {{amount}}",
		money_with_currency_format: "&#70;&#67; {{amount}} CDF"
	},
	CUC: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} CUC"
	},
	CUP: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} CUP"
	},
	DJF: {
		money_format: "&#70;&#100;&#106; {{amount}}",
		money_with_currency_format: "&#70;&#100;&#106; {{amount}} DJF"
	},
	ERN: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} ERN"
	},
	EEK: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} EEK"
	},
	FKP: {
		money_format: "&#163; {{amount}}",
		money_with_currency_format: "&#163; {{amount}} FKP"
	},
	GIP: {
		money_format: "&#163; {{amount}}",
		money_with_currency_format: "&#163; {{amount}} GIP"
	},
	XAU: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} XAU"
	},
	GGP: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} GGP"
	},
	GNF: {
		money_format: "&#70;&#71; {{amount}}",
		money_with_currency_format: "&#70;&#71; {{amount}} GNF"
	},
	HTG: {
		money_format: "&#71; {{amount}}",
		money_with_currency_format: "&#71; {{amount}} HTG"
	},
	XDR: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} XDR"
	},
	IRR: {
		money_format: "&#65020; {{amount}}",
		money_with_currency_format: "&#65020; {{amount}} IRR"
	},
	IQD: {
		money_format: "&#1593;.&#1583; {{amount}}",
		money_with_currency_format: "&#1593;.&#1583; {{amount}} IQD"
	},
	IMP: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} IMP"
	},
	LAK: {
		money_format: "&#8365; {{amount}}",
		money_with_currency_format: "&#8365; {{amount}} LAK"
	},
	LSL: {
		money_format: "&#76; {{amount}}",
		money_with_currency_format: "&#76; {{amount}} LSL"
	},
	LRD: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} LRD"
	},
	LYD: {
		money_format: "&#1604;.&#1583; {{amount}}",
		money_with_currency_format: "&#1604;.&#1583; {{amount}} LYD"
	},
	MWK: {
		money_format: "&#77;&#75; {{amount}}",
		money_with_currency_format: "&#77;&#75; {{amount}} MWK"
	},
	MRO: {
		money_format: "&#85;&#77; {{amount}}",
		money_with_currency_format: "&#85;&#77; {{amount}} MRO"
	},
	KPW: {
		money_format: "&#8361; {{amount}}",
		money_with_currency_format: "&#8361; {{amount}} KPW"
	},
	XPD: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} XPD"
	},
	PAB: {
		money_format: "&#66;&#47;&#46; {{amount}}",
		money_with_currency_format: "&#66;&#47;&#46; {{amount}} PAB"
	},
	XPT: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} XPT"
	},
	SHP: {
		money_format: "&#163; {{amount}}",
		money_with_currency_format: "&#163; {{amount}} SHP"
	},
	SVC: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} SVC"
	},
	SPL: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} SPL"
	},
	SLL: {
		money_format: "&#76;&#101; {{amount}}",
		money_with_currency_format: "&#76;&#101; {{amount}} SLL"
	},
	XAG: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} XAG"
	},
	SKK: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} SKK"
	},
	SBD: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} SBD"
	},
	SOS: {
		money_format: "&#83; {{amount}}",
		money_with_currency_format: "&#83; {{amount}} SOS"
	},
	SDG: {
		money_format: "&#163; {{amount}}",
		money_with_currency_format: "&#163; {{amount}} SDG"
	},
	SRD: {
		money_format: "&#36; {{amount}}",
		money_with_currency_format: "&#36; {{amount}} SRD"
	},
	SZL: {
		money_format: "&#76; {{amount}}",
		money_with_currency_format: "&#76; {{amount}} SZL"
	},
	TJS: {
		money_format: "&#84;&#74;&#83; {{amount}}",
		money_with_currency_format: "&#84;&#74;&#83; {{amount}} TJS"
	},
	TOP: {
		money_format: "&#84;&#36; {{amount}}",
		money_with_currency_format: "&#84;&#36; {{amount}} TOP"
	},
	TMT: {
		money_format: "&#109; {{amount}}",
		money_with_currency_format: "&#109; {{amount}} TMT"
	},
	TVD: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} TVD"
	},
	UZS: {
		money_format: "&#1083;&#1074; {{amount}}",
		money_with_currency_format: "&#1083;&#1074; {{amount}} UZS"
	},
	YER: {
		money_format: "&#65020; {{amount}}",
		money_with_currency_format: "&#65020; {{amount}} YER"
	},
	ZWD: {
		money_format: "{{amount}}",
		money_with_currency_format: "{{amount}} ZWD"
	}
};

DoublyCurrency.formatMoney = function (cents, format, isShopCurrency, hasSup) {
	function defaultOption(opt, def) {
		if (typeof opt == "undefined") {
			return def;
		} else {
			return opt;
		}
	}

	let sign = ''

	if (cents < 0) {
		cents = Math.abs(cents)
		sign = '-'

	}

	function formatWithDelimiters(number, precision, thousands, decimal) {

		number = Math.abs(number)

		precision = defaultOption(precision, 0);
		thousands = defaultOption(thousands, ",");
		decimal = defaultOption(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		
		number = (number / 100).toFixed(precision);
		var parts = number.split(".")
			, dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands)
			, cents = parts[1] ? (decimal + parts[1]) : "";
		if (hasSup) {
			return dollars + "<sup>" + cents + "</sup>";
		} else {
			return dollars + cents;
		}
	}
	if (typeof cents == "string") {
		cents = cents.replace(".", "");
	}
	var value = ""
		, placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
		, formatString = format || "${{amount}}"
		, decimals = 2;
	if ((!isShopCurrency && (DoublyCurrency.currentCurrency == "KWD" || DoublyCurrency.currentCurrency == "BHD" || DoublyCurrency.currentCurrency == "JOD" || DoublyCurrency.currentCurrency == "OMR")) || (isShopCurrency && (shopCurrency == "KWD" || shopCurrency == "BHD" || shopCurrency == "JOD" || shopCurrency == "OMR"))) {
		decimals = 3;
	}
	if (DoublyGlobal.removeDecimals || true) {
		decimals = 0;
	}
	if ((!isShopCurrency && DoublyCurrency.currentCurrency == "BTC") || (isShopCurrency && shopCurrency == "BTC")) {
		decimals = 8;
	}
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, decimals);
			if (DoublyGlobal.roundDecimals && !isShopCurrency && this.currentCurrency != shopCurrency && this.currentCurrency != "BTC" && value != 0 && value.toString().indexOf(".") !== -1) {
				value = value.substr(0, (value.toString().indexOf(".") + 1)) + DoublyGlobal.roundTo;
				if (DoublyCurrency.currentCurrency == "KWD" || DoublyCurrency.currentCurrency == "BHD" || DoublyCurrency.currentCurrency == "JOD" || DoublyCurrency.currentCurrency == "OMR") {
					value += "0";
				}
				if (hasSup) {
					value += "</sup>";
				}
			}
			break;
		case "amount_with_comma_separator":
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, decimals, ".", ",");
			if (DoublyGlobal.roundDecimals && !isShopCurrency && this.currentCurrency != shopCurrency && this.currentCurrency != "BTC" && value.toString().replace(",", ".") != 0 && value.toString().indexOf(",") !== -1) {
				value = value.substr(0, (value.toString().indexOf(",") + 1)) + DoublyGlobal.roundTo;
				if (DoublyCurrency.currentCurrency == "KWD" || DoublyCurrency.currentCurrency == "BHD" || DoublyCurrency.currentCurrency == "JOD" || DoublyCurrency.currentCurrency == "OMR") {
					value += "0";
				}
				if (hasSup) {
					value += "</sup>";
				}
			}
	}
	if (!isNaN(cents)) {
		return sign + formatString.replace(placeholderRegex, value)
	} else {
		return ""
	}
};

const customVueComponents = {

  'custom-price': {
      data() {

          return {
          count: 0
          }
      },
      methods:{
          formatMoney(price){

            let [int, cents] = Shopify.formatMoney(price).split('.')
            
            // let value = Shopify.formatMoney(price)

						let value = store.state.currency.rates?.convert(price, 'MXN', store.state.currency.current )
						DoublyCurrency.currentCurrency = store.state.currency.current
						const format = DoublyCurrency?.moneyFormats[store.state.currency.current].money_with_currency_format
						let formattedValue = DoublyCurrency?.formatMoney(value, format, false, true)

						let formatoSinDivisa = formattedValue.split(' ')

						let divisa = formatoSinDivisa.pop()

						if (formatoSinDivisa.join(' ')) {
							return `${formatoSinDivisa.join(' ')}<span class="cents">${divisa}</span>`
							
						}else{

							return `${divisa}`
						}


          },
          getDiscountProduct(item){
          // return a
            return item.original_price != item.price
          },
          
      },
      computed: {
          getPrice(){

            const sku =  this.sku ||( this.product? this.product?.sku : '')
            return item.price
            
          },
          getPriceOld(){

            const sku =  this.sku ||( this.product? this.product?.sku : '')
            return item.price

          },
          getDiscount(){

            
            return store.state.customer.discount
          },
          isWholesale(){
            return store.state.customer.isWholesale
          },
          numItems(){
              return store.state.cart?.data?.item_count * this.price
          },
          total(){
              return Shopify.formatMoney(store.state.cart?.data?.total_price)
          },
          getBoolDiscount() {
            const bool1 = !store.state.customer.isWholesale && store.state.cart?.data?.items.some(x=>x.selling_plan_allocation)
            return /* store.state.customer.isWholesale && */ /* store.state.customer.discount < 1 &&  */!bool1
          },

      },
      props: [ 'quantity','sku', 'price','money_price', 'classes', 'classes_after' , 'product', 'hide_before', 'hide_dsc_tag','original_price', 'show_dsc'],
      template: `
      
<template v-if="!hide_dsc_tag">

    <div class="descuento-especial caption" v-if="product?.discount">
        <div class="align-items-center flex font-header gap-0-5rem p-5px">
            <i class="fas fa-tags"></i>
            <span class="dsc-title"> {{product?.discount.name}}</span>
        </div>
    </div>
</template>

<template v-if="getBoolDiscount || show_dsc">
    <template v-if="original_price != price  && original_price">

        <!-- -if -->
        <div class="price bold" v-bind:class="[classes_after]" v-html="product?.priceFormatted">
        </div>

        <div>
            <span class="visually-hidden visually-hidden--inline price price-item"></span>
        </div>
        <span v-if="!hide_before">
            <s v-bind:class="[classes, 'price-item--sale']" v-html="formatMoney(product?.original_price)"> </s>
        </span>
    </template>
    <template v-else-if="isWholesale && false && (sku || (product ?  product.sku : false))">
        <!-- -else-if -->
        <div class="price bold" v-bind:class="[classes_after]" v-html="formatMoney(getPrice*(quantity || 1))">
            
        </div>
        <div>
            <span class="visually-hidden visually-hidden--inline price price-item"></span>
        </div>
        <span v-if="!hide_before">
            <s v-bind:class="[classes, 'price-item--sale']" v-html="formatMoney(price)"> </s>
        </span>
    </template>
    <!-- -else -->
    <div v-bind:class="[classes]" else1 v-else v-html="formatMoney(price)">
        {{ formatMoney(price) }}
    </div>
</template>

<div  v-bind:class="[classes, ]" class="w-100" else2 v-else v-html="formatMoney(price)">

</div>
      
          `
          
          // <span class>{{numItems}}</span>
  },

  'custom-price-a': {
    data() {

        return {
        count: 0
        }
    },
    methods:{
        formatMoney(price){

          let [int, cents] = Shopify.formatMoney(price).split('.')
          
          // let value = Shopify.formatMoney(price)

          let value = store.state.currency.rates?.convert(price, 'MXN', store.state.currency.current )
          DoublyCurrency.currentCurrency = store.state.currency.current
          const format = DoublyCurrency?.moneyFormats[store.state.currency.current].money_with_currency_format
          let formattedValue = DoublyCurrency?.formatMoney(value, format, false, true)

          let formatoSinDivisa = formattedValue.split(' ')

          let divisa = formatoSinDivisa.pop()

          if (formatoSinDivisa.join(' ')) {
            return `${formatoSinDivisa.join(' ')}<span class="cents">${divisa}</span>`
            
          }else{

            return `${divisa}`
          }


        },
        getDiscountProduct(item){
        // return a
          return item.original_price != item.price
        },
        
    },
    computed: {
        getPrice(){

          const sku =  this.sku ||( this.product? this.product?.sku : '')
          return item.price
          
        },
        getPriceOld(){

          const sku =  this.sku ||( this.product? this.product?.sku : '')
          return item.price

        },
        getDiscount(){

          
          return store.state.customer.discount
        },
        isWholesale(){
          return store.state.customer.isWholesale
        },
        numItems(){
            return store.state.cart?.data?.item_count * this.price
        },
        total(){
            return Shopify.formatMoney(store.state.cart?.data?.total_price)
        },
        getBoolDiscount() {
          const bool1 = !store.state.customer.isWholesale && store.state.cart?.data?.items.some(x=>x.selling_plan_allocation)
          return true
        },

    },
    props: [ 'quantity','sku', 'price','money_price', 'classes', 'classes_after' , 'product', 'hide_before', 'hide_dsc_tag','original_price', 'show_dsc'],
    template: `
    


<template v-if="getBoolDiscount">
  <div v-bind:class="[classes]" else1 v-else v-html="formatMoney(price)">
      {{ formatMoney(price) }}
  </div>
</template>

<div  v-bind:class="[classes, ]" class="w-100" else2 v-else v-html="formatMoney(price)">

</div>
    
        `
        
        // <span class>{{numItems}}</span>
},


    
  'price-sku-a': {
    data() {

        return {
        count: 0
        }
    },
    methods:{
        formatMoney(price){

          let [int, cents] = Shopify.formatMoney(price).split('.')
          
          // let value = Shopify.formatMoney(price)

          let value = store.state.currency.rates?.convert(price, 'MXN', store.state.currency.current )
          DoublyCurrency.currentCurrency = store.state.currency.current
          const format = DoublyCurrency?.moneyFormats[store.state.currency.current].money_with_currency_format
          let formattedValue = DoublyCurrency?.formatMoney(value, format, false, true)

          let formatoSinDivisa = formattedValue.split(' ')

          let divisa = formatoSinDivisa.pop()

          if (formatoSinDivisa.join(' ')) {
            return `${formatoSinDivisa.join(' ')}<span class="cents">${divisa}</span>`
            
          }else{

            return `${divisa}`
          }
        },
        formatMoneySinFormato(price){


          return Shopify.formatMoney(price)
        },
        getPriceSKU(sku){
          return sku
        },
        getPriceSKA(ska){
          precio = store.state.selectedVariant.price / 100
          descuento = (precio * ska ) / 100
          precio_descuento = (precio - descuento) * 100
          return precio_descuento
        }
        
    },
    computed: {
      getVariantSelected(){
      
        return store.state.selectedVariant
      },
      getProductSelected(){
        return store.state.selectedProduct
      },
      getProductSelectedUnitPriceText(){
        return store.state.selectedProductUnitPriceText ||  "cápsula"
      },
      admin(){
        return store.state.admin
      },
      isWholesale(){
        return store.state.customer.isWholesale
      },
      getPrice(){
        return store.state.selectedVariant.price
      },
      prueba1(){
        return store.state.listaPrecios.find(x=>x.SKU == store.state.selectedVariant.sku)
      },
      prueba2(){
        return store.state.selectedVariant.sku
      },
      isAdmin(){
        return store.state.admin
      },
      productSKU(){
        return store.state.selectedVariant.sku
      }
    },
    props: ['sku', 'ska'],
    template: `
    <template v-if="isWholesale && false">
      <div class="mb-2">
          <legend class="form__label">Precio público</legend>
          <span class="bold text-large" v-html="formatMoney(getVariantSelected.price)"></span>
      </div>
      <div class="flex gap-0-5rem" style="gap: 2rem;">
          <div class="">
              <legend class="form__label">Tu precio</legend>
              <span class="badge badge-danger bold text-medium-small text-white" style="padding: 1rem 1rem;" v-html="formatMoney(getPrice)">
              
              </span>
          </div>
          <div class="">
              <legend class="form__label">Tu ganancia</legend>
              <span class="badge bold text-medium-small" style="padding: 1rem 1rem;" v-html="formatMoney(getVariantSelected.price-getPrice)">
                  
              </span>
          </div>
      </div>
    </template>
    <template v-else>
      <div class="mb-2 flex " style="gap: 2rem;">
        <div>
          <legend class="form__label"></legend>
          <div class="d-flex flex-column" >
            <span class="bold price-item--sale" v-if="" v-html="formatMoney(getVariantSelected.price)">
            </span>
            <div class="flex align-items-center gap-0-5rem" >
              <span class="bold text-large" v-html="formatMoney(getPriceSKA(ska))"></span>
              <span v-if="!productSKU?.startsWith('WU-MR-') && getProductSelected" class="bold text-small" 
              v-html="'('+formatMoneySinFormato(getPriceSKA(ska)/getProductSelected)+' / '+getProductSelectedUnitPriceText+')'"> </span>
            </div>
          </div>
        </div>

      </div>
    </template>

        `
},
  
  'price-sku': {
      data() {

          return {
          count: 0
          }
      },
      methods:{
          formatMoney(price){

            let [int, cents] = Shopify.formatMoney(price).split('.')
            
            // let value = Shopify.formatMoney(price)

						let value = store.state.currency.rates?.convert(price, 'MXN', store.state.currency.current )
						DoublyCurrency.currentCurrency = store.state.currency.current
						const format = DoublyCurrency?.moneyFormats[store.state.currency.current].money_with_currency_format
						let formattedValue = DoublyCurrency?.formatMoney(value, format, false, true)

						let formatoSinDivisa = formattedValue.split(' ')

						let divisa = formatoSinDivisa.pop()

						if (formatoSinDivisa.join(' ')) {
							return `${formatoSinDivisa.join(' ')}<span class="cents">${divisa}</span>`
							
						}else{

							return `${divisa}`
						}
          },
          formatMoneySinFormato(price){


            return Shopify.formatMoney(price)
          },
          getPriceSKU(sku){
            return sku
          },
          
      },
      computed: {
        getVariantSelected(){
          
          return store.state.selectedVariant
        },
        getProductSelected(){
          return store.state.selectedProduct
        },
        getProductSelectedUnitPriceText(){
          return store.state.selectedProductUnitPriceText ||  "cápsula"
        },
        admin(){
          return store.state.admin
        },
        isWholesale(){
          return store.state.customer.isWholesale
        },
        getPrice(){
          return store.state.selectedVariant.price
        },
        prueba1(){
          return store.state.listaPrecios.find(x=>x.SKU == store.state.selectedVariant.sku)
        },
        prueba2(){
          return store.state.selectedVariant.sku
        },
        isAdmin(){
          return store.state.admin
        },
        productSKU(){
          return store.state.selectedVariant.sku
        }
      },
      props: ['sku'],
      template: `
      <template v-if="isWholesale && false">
        <div class="mb-2">
            <legend class="form__label">Precio público</legend>
            <span class="bold text-large" v-html="formatMoney(getVariantSelected.price)"></span>
        </div>
        <div class="flex gap-0-5rem" style="gap: 2rem;">
            <div class="">
                <legend class="form__label">Tu precio</legend>
                <span class="badge badge-danger bold text-medium-small text-white" style="padding: 1rem 1rem;" v-html="formatMoney(getPrice)">
                
                </span>
            </div>
            <div class="">
                <legend class="form__label">Tu ganancia</legend>
                <span class="badge bold text-medium-small" style="padding: 1rem 1rem;" v-html="formatMoney(getVariantSelected.price-getPrice)">
                    
                </span>
            </div>
        </div>
      </template>
      <template v-else>
        <div class="mb-2 flex " style="gap: 2rem;">
          <div>
            <legend class="form__label"></legend>
            <div class="d-flex flex-column" >
              <span class="bold price-item--sale" v-if="getVariantSelected?.compare_at_price" v-html="formatMoney(getVariantSelected.compare_at_price)">
              </span>
              <div class="flex align-items-center gap-0-5rem" >
                <span class="bold text-large" v-html="formatMoney(getVariantSelected.price)"></span>
                <span v-if="!productSKU?.startsWith('WU-MR-') && getProductSelected" class="bold text-small" 
								v-html="'('+formatMoneySinFormato(getVariantSelected.price/getProductSelected)+' / '+getProductSelectedUnitPriceText+')'"> </span>
              </div>
            </div>
          </div>

        </div>
      </template>

          `
  },

  'just-price-sku': {
      data() {

          return {
          count: 0
          }
      },
      methods:{
          formatMoney(price){

            return Shopify.formatMoney(price)
          },
          getPriceSKU(sku){
            return sku
          },
          addToCart(id, qty){



            store.dispatch('addToCart', {id, qty})
            .then((response) => {
    
            })
          },
      },
      computed: {
        getVariantSelected(){
          return store.state.selectedVariant
        },
        admin(){
          return store.state.admin
        },
        isWholesale(){
          return store.state.customer.isWholesale
        },
        getPrice(){
          return (store.state.listaPrecios.find(x=>x.SKU == store.state.selectedVariant.sku)?.Precio*100 || store.state.selectedVariant.price)
        },
        prueba1(){
          return store.state.listaPrecios.find(x=>x.SKU == store.state.selectedVariant.sku)
        },
        prueba2(){
          return store.state.selectedVariant.sku
        },
      },
      props: ['sku'],
      template: `
      <template v-if="isWholesale">
        {{ formatMoney(getPrice)}}
      </template>
      <template v-else>
          {{ formatMoney(getVariantSelected.price) }}
      </template>
          `
  }



}


const mountVueComponent = (app, name ) => {

  return app.component(name,customVueComponents[name] )

}

const checkAgregarMultiploProductos = ( sku, qty, multiplo) => {

  const agregar = Math.floor(qty/multiplo)

  if(agregar > 0){

      
      return {
          sku,
          qty: agregar,
          quantity: agregar
      }


  }else{

      return null

  }

}

let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

document.querySelector('.eye-password')?.addEventListener('click', function(){

  const input = this.parentElement.querySelector('input')
  const classes = this.classList//.split(/\s+/)

  const show = classes.contains('hide-password')

  if(show){
    this.classList.remove('hide-password')
    this.classList.remove('fa-eye')
    this.classList.add('fa-eye-slash')
    
    
    input.setAttribute('type', 'text')
    
  }else{

    this.classList.add('hide-password')
    this.classList.add('fa-eye')
    this.classList.remove('fa-eye-slash')
  
    input.setAttribute('type', 'password')


  }

})

if(window.location.pathname == '/cart'){

  window.location.href = '/?code=000'
}

let subsRecharge = document.querySelector('#rc_link_container a')

if(subsRecharge){

  subsRecharge.innerHTML = "Manejar suscripciones";

}

let arr = document.querySelectorAll('[href^="#"], [data-href]')

arr.forEach(item=>{

  item.addEventListener('click', function (event) {

    event.preventDefault()
    const target = this
    var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');
  
    let offsetDefault = 10
  
    if (selector === '#' || selector === '#main') {
      return;
    } 
  
    var element = document.querySelector(selector),
        offset = parseInt(target.getAttribute('data-offset') || 0);
  
  
    if (target.hasAttribute('data-focus-on-click')) {
      var prevScrollY = window.pageYOffset;
      element.focus({
        preventScroll: true
      }); // hack to fix scroll jump after focus
  
      if (window.pageYOffset !== prevScrollY) {
  
        console.log('Prueba1');
        window.scrollTo(window.pageXOffset, prevScrollY);
      }
      
      element.focus();
    }
  
    
    console.log('Prueba2');
    window.scrollTo({
      behavior: 'smooth',
      top: element.offsetTop - offset - offsetDefault
    });
    event.preventDefault();
  })

})

if( window.location.pathname == '/pages/suplemento-ideal-quiz' ) {

  document.addEventListener('click', function(evt) {

    const item = evt.target

    const id = item.getAttribute("data-variant-id")
    const id2 = item.id == ("quiz-kit-results-add-all-button-6dcTjEDNZt")



    if(id2 && item.tagName == 'BUTTON'){

      item.innerHTML = (`<svg height="20" aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>`)

      setTimeout(() => {
        
        store.dispatch('getCart',{openCart: true})

        setTimeout(() => {
          
          item.innerHTML="AGREGAR TODOS A CARRITO"
        }, 500);

      }, 400);

    }

    if(id && item.tagName == 'BUTTON'){

      item.innerHTML = (`<svg height="20" aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
    </svg>`)


      setTimeout(() => {
        store.dispatch('getCart',{openCart: true})

        setTimeout(() => {
          
          item.innerHTML="AGREGAR A CARRITO"
        }, 500);

      }, 400);
    }

    // if(item.tagName)
  }, false);

}




// $(function() {
//   $('details').on('mouseover', function() {
// 		console.log('open :>> ' );
//     $(this).attr('open', true);
//   }).on('mouseout', function() {
//     $(this).attr('open', false);
//   })
// });

function onMouseEnter(evt){
	evt.parentElement.click()//setAttribute('open', true)
} 
// function onMouseLeave(evt){
// 	console.log('asdasdasdasd');
// 	console.log('evt :>> ', evt);
// 	evt.parentElement.setAttribute('open', true)
// }

